import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  constructor(private http: HttpClient) { }
  getList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`payment/getList/${lasyP}`));
  }

  paymentGetById(id: any) {
    return lastValueFrom(this.http.get(`payment/getById/${id}`));
  }
  paymentSave(id: any) {
    return lastValueFrom(this.http.post(`payment/save`, id));
  }
}
